module.exports = __webpack_public_path__ + "img/błąd allegro.25523e0b.png";